import { RunGroupFormValues } from "@features/run/RunGroupDialog/RunGroupForm"
import { TextField } from "@mui/material"
import { getErrorMessage } from "@utils/form"
import { Controller, useFormContext } from "react-hook-form"

export const RunGroupFieldDescription = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext<RunGroupFormValues>()
  return (
    <Controller
      name="description"
      control={control}
      render={({ field }) => (
        <TextField
          error={Boolean(errors[field.name])}
          helperText={getErrorMessage(errors, field.name)}
          label="Description"
          variant="standard"
          multiline
          {...field}
        />
      )}
    />
  )
}
